module.exports = __webpack_public_path__ + "img/教育用户.5e90f1ed.png";